export default __webpack_public_path__ + "static/media/RT-3.66557fcb.svg";